class $37ce132ae33171bd$export$a4d4c1df08f53d70 extends Phaser.Scene {
    constructor(stageNumber, enemyInfo, obstacleInfo, starInfo){
        super({
            key: `GameScene${stageNumber}`
        });
        this.stage = stageNumber;
        this.enemyInfo = enemyInfo;
        this.obstacleInfo = obstacleInfo;
        this.starInfo = starInfo;
        this.score = 0;
        this.timeLeft = 120;
    }
    preload() {
        this.load.image("sky", "/assets/sky.png");
        this.load.image("wall", "/assets/platform.png");
        this.load.image("star", "/assets/star.png");
        this.load.image("setting", "/assets/setting.png");
        this.load.spritesheet("dude", "/assets/dude.png", {
            frameWidth: 32,
            frameHeight: 48
        });
    }
    create() {
        if (this.playerHitbox) this.playerHitbox.destroy();
        // 背景
        this.add.image(400, 300, "sky");
        // プラットフォーム
        this.platforms = this.physics.add.staticGroup();
        this.platforms.create(400, 32, "wall").setScale(2).refreshBody();
        this.platforms.create(400, 568, "wall").setScale(2).refreshBody();
        // 設定ボタン
        this.add.image(750, 40, "setting").setScale(0.4).setInteractive().on("pointerdown", ()=>{
            this.scene.pause();
            this.scene.launch("PauseScene", {
                stage: this.stage,
                newScore: this.score
            });
        });
        // スコアとタイマー
        this.scoreText = this.add.text(30, 30, `\u{30B9}\u{30B3}\u{30A2}: ${this.score}`, {
            fontSize: "20px",
            fill: "#fff"
        });
        this.timerText = this.add.text(30, 60, `\u{6642}\u{9593}: ${this.timeLeft}`, {
            fontSize: "20px",
            fill: "#fff"
        });
        this.timerEvent = this.time.addEvent({
            delay: 1000,
            callback: ()=>this.updateTimer(),
            loop: true
        });
        // プレイヤー
        this.player = this.physics.add.sprite(100, 450, "dude").setCollideWorldBounds(true);
        this.createPlayerAnimations();
        // **プレイヤーの当たり判定を可視化**
        this.playerHitbox = this.add.graphics();
        this.playerHitbox.fillStyle(0x00ff00, 0.3); // 緑色の透明な矩形
        // 障害物の作成（各ステージごとに異なる）
        this.createObstacles();
        // 敵の作成（各ステージごとに異なる）
        this.createEnemies();
        // ゴール
        this.createGoal();
        // スター
        this.createStar();
        // 衝突設定
        this.physics.add.collider(this.player, this.platforms);
    }
    updateTimer() {
        if (this.timeLeft > 0) {
            this.timeLeft--;
            this.timerText.setText(`\u{6642}\u{9593}: ${this.timeLeft}`);
        } else {
            this.resetGame();
            this.scene.launch("GameOverScene");
        }
    }
    resetGame() {
        this.player.setPosition(100, 450);
        this.player.setScale(1);
        this.score = 0;
        this.scoreText.setText(`\u{30B9}\u{30B3}\u{30A2}: ${this.score}`);
        this.timeLeft = 120;
        this.timerText.setText(`\u{6642}\u{9593}: ${this.timeLeft}`);
        if (this.playerHitbox) {
            this.playerHitbox.destroy();
            this.playerHitbox = null;
        }
        if (this.stars) this.stars.children.iterate((star)=>{
            star.enableBody(true, star.x, star.y, true, true);
        });
    }
    createPlayerAnimations() {
        this.anims.create({
            key: "left",
            frames: this.anims.generateFrameNumbers("dude", {
                start: 0,
                end: 3
            }),
            frameRate: 10,
            repeat: -1
        });
        this.anims.create({
            key: "right",
            frames: this.anims.generateFrameNumbers("dude", {
                start: 5,
                end: 8
            }),
            frameRate: 10,
            repeat: -1
        });
        this.anims.create({
            key: "turn",
            frames: [
                {
                    key: "dude",
                    frame: 4
                }
            ],
            frameRate: 20
        });
    }
    createObstacles() {
        this.obstacles = this.physics.add.staticGroup();
        this.obstacleInfo.forEach((obs)=>{
            const block = this.add.rectangle(obs.x, obs.y, obs.w, obs.h, 0xaa0000);
            this.physics.add.existing(block, true);
            this.obstacles.add(block);
        });
        this.physics.add.collider(this.player, this.obstacles);
    }
    createEnemies() {
        this.enemies = this.physics.add.group({
            collideWorldBounds: true
        });
        this.enemyInfo.forEach((ene)=>{
            const enemy = this.physics.add.sprite(ene.x, ene.y, "dude");
            this.enemies.add(enemy);
            enemy.setVelocityY(ene.velocity.y);
            enemy.setBounce(1, 1);
            enemy.setCollideWorldBounds(true);
            enemy.body.allowGravity = false;
            enemy.rotate = ene.rotate;
            //敵が壁に衝突
            this.physics.add.collider(this.enemies, this.obstacles, (enemy)=>{
                if (enemy.rotate) {
                    // ランダムに 90度回転
                    // 方向を変更
                    const currentVelocityX = enemy.body.velocity.x;
                    const currentVelocityY = enemy.body.velocity.y;
                    // ランダムに X/Y を切り替え
                    enemy.setVelocityX(currentVelocityY);
                    enemy.setVelocityY(-currentVelocityX);
                }
            });
            this.physics.add.collider(this.enemies, this.platforms, (enemy)=>{
                if (enemy.rotate) {
                    // 方向を変更
                    const currentVelocityX = enemy.body.velocity.x;
                    const currentVelocityY = enemy.body.velocity.y;
                    // ランダムに X/Y を切り替え
                    enemy.setVelocityX(currentVelocityY);
                    enemy.setVelocityY(-currentVelocityX);
                }
            });
            //ぐるぐる回る敵
            if (ene.circle) {
                enemy.setVelocityX(ene.velocity.x);
                enemy.distanceTraveled = 0;
                this.physics.world.on("worldstep", ()=>{
                    const velocityX = enemy.body.velocity.x;
                    const velocityY = enemy.body.velocity.y;
                    const speed = Math.sqrt(velocityX ** 2 + velocityY ** 2);
                    enemy.distanceTraveled += speed * this.game.loop.delta / 1000;
                    if (enemy.distanceTraveled >= 150) {
                        enemy.distanceTraveled = 0;
                        enemy.setVelocityX(-velocityY);
                        enemy.setVelocityY(velocityX);
                    }
                });
            }
            //敵の当たり判定
            const hitboxWidth = enemy.width * ene.hitSize.width;
            const hitboxHeight = enemy.height * ene.hitSize.height;
            enemy.setSize(hitboxWidth, hitboxHeight);
            enemy.setOffset((enemy.width - hitboxWidth) / 2, (enemy.height - hitboxHeight) / 2);
            const hitboxGraphics = this.add.graphics();
            hitboxGraphics.fillStyle(0xff0000, 0.3);
            hitboxGraphics.fillRect(enemy.x - hitboxWidth / 2, enemy.y - hitboxHeight / 2, hitboxWidth, hitboxHeight);
            this.physics.world.on("worldstep", ()=>{
                hitboxGraphics.clear();
                hitboxGraphics.fillStyle(0xff0000, 0.3);
                hitboxGraphics.fillRect(enemy.x - hitboxWidth / 2, enemy.y - hitboxHeight / 2, hitboxWidth, hitboxHeight);
            });
        });
        this.physics.add.overlap(this.player, this.enemies, ()=>{
            this.scene.pause();
            this.scene.launch("GameOver");
            this.resetGame();
        });
    }
    createGoal() {
        const goal = this.add.rectangle(750, 70, 100, 10, 0x00ff00);
        this.physics.add.existing(goal);
        goal.body.setImmovable(true);
        goal.body.allowGravity = false;
        this.physics.add.overlap(this.player, goal, ()=>{
            this.score += 1000 + this.timeLeft * 10;
            localStorage.setItem(`Stage${this.stage}NewScore`, this.score);
            this.scene.pause();
            this.scene.launch("ResultScene", {
                stage: this.stage,
                newScore: this.score
            });
            this.resetGame();
        });
    }
    createStar() {
        this.stars = this.physics.add.group();
        this.starInfo.forEach((starData)=>{
            const star = this.physics.add.sprite(starData.x, starData.y, "star").setDepth(10);
            this.stars.add(star);
        });
        this.physics.add.overlap(this.player, this.stars, (player, star)=>{
            star.disableBody(true, true);
            this.score += 1000;
            this.player.setScale(1.4);
            this.scoreText.setText(`\u{30B9}\u{30B3}\u{30A2}: ${this.score}`);
        });
    }
    updatePlayerHitbox() {
        if (!this.playerHitbox) return;
        this.playerHitbox.clear(); // 以前の描画をクリア
        this.playerHitbox.fillStyle(0x00ff00, 0.3); // 緑色
        this.playerHitbox.fillRect(this.player.body.position.x, this.player.body.position.y, this.player.body.width, this.player.body.height // 高さ
        );
    }
    update() {
        this.cursors = this.input.keyboard.createCursorKeys();
        if (this.cursors.left.isDown) {
            this.player.setVelocityX(-160);
            this.player.anims.play("left", true);
        } else if (this.cursors.right.isDown) {
            this.player.setVelocityX(160);
            this.player.anims.play("right", true);
        } else {
            this.player.setVelocityX(0);
            this.player.anims.play("turn");
        }
        if (this.cursors.up.isDown) this.player.setVelocityY(-160);
        else if (this.cursors.down.isDown) this.player.setVelocityY(160);
        else this.player.setVelocityY(0);
        this.updatePlayerHitbox();
    }
}


const $f87ce123b66b4b44$var$enemyInfo = [
    {
        name: 2,
        x: 300,
        y: 150,
        w: 40,
        h: 30,
        rotate: true,
        circle: false,
        hitSize: {
            height: 3,
            width: 1
        },
        velocity: {
            x: 150,
            y: 150
        }
    },
    {
        name: 3,
        x: 400,
        y: 100,
        w: 30,
        h: 30,
        rotate: false,
        circle: true,
        hitSize: {
            height: 1.5,
            width: 1
        },
        velocity: {
            x: 150,
            y: 150
        }
    },
    {
        name: 4,
        x: 500,
        y: 250,
        w: 30,
        h: 30,
        rotate: false,
        circle: false,
        hitSize: {
            height: 1.5,
            width: 4
        },
        velocity: {
            x: 150,
            y: 150
        }
    }
];
const $f87ce123b66b4b44$var$obstacleInfo = [
    {
        x: 300,
        y: 500,
        w: 50,
        h: 300
    },
    {
        x: 200,
        y: 150,
        w: 50,
        h: 500
    }
];
const $f87ce123b66b4b44$var$starInfo = [
    {
        x: 100,
        y: 300
    }
];
class $f87ce123b66b4b44$export$3b63e1c55a110ee1 extends (0, $37ce132ae33171bd$export$a4d4c1df08f53d70) {
    constructor(){
        super(1, $f87ce123b66b4b44$var$enemyInfo, $f87ce123b66b4b44$var$obstacleInfo, $f87ce123b66b4b44$var$starInfo);
    }
}


class $784de5bb9f279709$export$c06ab21c92d34448 extends Phaser.Scene {
    constructor(){
        super({
            key: "StageSelectScene"
        });
    }
    create() {
        let storedName = localStorage.getItem("playerName");
        this.add.text(200, 50, "\u30B9\u30C6\u30FC\u30B8\u9078\u629E", {
            fontSize: "32px",
            fill: "#fff"
        });
        for(let i = 1; i <= 5; i++){
            let button = this.add.text(200, 100 + i * 50, `Stage ${i}`, {
                fontSize: "24px",
                fill: "#0f0"
            }).setInteractive().on("pointerdown", ()=>this.scene.start(`GameScene${i}`)).on("pointerover", ()=>button.setStyle({
                    fill: "#ff0"
                })).on("pointerout", ()=>button.setStyle({
                    fill: "#0f0"
                }));
        }
        let rankButton = this.add.text(200, 400, `\u{30E9}\u{30F3}\u{30AD}\u{30F3}\u{30B0}`, {
            fontSize: "24px",
            fill: "#0f0"
        }).setInteractive().on("pointerdown", ()=>this.scene.start(`RankScene`)).on("pointerover", ()=>rankButton.setStyle({
                fill: "#ff0"
            })).on("pointerout", ()=>rankButton.setStyle({
                fill: "#0f0"
            }));
        this.add.text(400, 100, `${storedName} \u{3055}\u{3093}\u{306E}\u{6700}\u{9AD8}\u{70B9}`, {
            fontSize: "24px",
            fill: "#fff"
        });
        for(let i = 1; i <= 5; i++){
            let topScore = localStorage.getItem(`Stage${i}TopScore`) || 0;
            this.add.text(400, 100 + i * 50, ` ${topScore}`, {
                fontSize: "24px",
                fill: "#fff"
            });
        }
    }
}


class $a3369f401e9b2582$export$9fd98d795f8d8487 extends Phaser.Scene {
    constructor(){
        super({
            key: "PauseScene"
        });
    }
    init(data) {
        this.stage = data.stage || 1; // デフォルトでステージ1
    }
    create() {
        this.add.text(250, 150, "\u4E00\u6642\u505C\u6B62", {
            fontSize: "32px",
            fill: "#ffffff"
        });
        const backButton = this.add.text(250, 250, "\u30B9\u30C6\u30FC\u30B8\u9078\u629E\u3078\u623B\u308B", {
            fontSize: "24px",
            fill: "#ffffff",
            padding: {
                x: 10,
                y: 5
            }
        }).setInteractive({
            useHandCursor: true
        }).setDepth(10).on("pointerover", ()=>backButton.setStyle({
                fill: "#ff0"
            })).on("pointerout", ()=>backButton.setStyle({
                fill: "#ffffff"
            })).on("pointerdown", ()=>{
            this.scene.stop(`GameScene${this.stage}`);
            this.scene.start("StageSelectScene");
        });
        const retryButton = this.add.text(250, 320, "\u3084\u308A\u76F4\u3059", {
            fontSize: "24px",
            fill: "#ffffff",
            padding: {
                x: 10,
                y: 5
            }
        }).setInteractive({
            useHandCursor: true
        }).setDepth(10).on("pointerover", ()=>retryButton.setStyle({
                fill: "#ff0"
            })).on("pointerout", ()=>retryButton.setStyle({
                fill: "#ffffff"
            })).on("pointerdown", ()=>{
            this.scene.stop(); // PauseScene を閉じる
            this.scene.get(`GameScene${this.stage}`).scene.restart(); // 該当の GameScene を再スタート
        });
        // キャンセルボタン
        const cancelButton = this.add.text(250, 420, "\u30AD\u30E3\u30F3\u30BB\u30EB", {
            fontSize: "24px",
            fill: "#ffffff",
            padding: {
                x: 10,
                y: 5
            }
        }).setInteractive({
            useHandCursor: true
        }).setDepth(10).on("pointerover", ()=>cancelButton.setStyle({
                fill: "#ff0"
            })).on("pointerout", ()=>cancelButton.setStyle({
                fill: "#ffffff"
            })).on("pointerdown", ()=>{
            this.scene.stop(); // 一時停止シーンを終了
            this.scene.resume(`GameScene${this.stage}`); // 該当の GameScene を再開
        });
    }
}


const $13f7e2bb7e104b70$var$API_BASE_URL = "https://yanki-game.onrender.com";
async function $13f7e2bb7e104b70$export$bfab3f324e8bcfbb(playerName, stage, score) {
    const res = await fetch(`${$13f7e2bb7e104b70$var$API_BASE_URL}/scores`, {
        method: "POST",
        headers: {
            "Content-Type": "application/json"
        },
        body: JSON.stringify({
            playerName: playerName,
            stage: stage,
            score: score
        })
    });
    return await res.json();
}
async function $13f7e2bb7e104b70$export$99f9e493cb5d4ab9() {
    const res = await fetch(`${$13f7e2bb7e104b70$var$API_BASE_URL}/scores`);
    return await res.json();
}
async function $13f7e2bb7e104b70$export$f37715246c986f89(playerName) {
    const res = await fetch(`${$13f7e2bb7e104b70$var$API_BASE_URL}/scores/${playerName}`);
    return await res.json();
}
async function $13f7e2bb7e104b70$export$482310739c8f9d71(id, playerName, stage, score) {
    const res = await fetch(`${$13f7e2bb7e104b70$var$API_BASE_URL}/scores/${id}`, {
        method: "PUT",
        headers: {
            "Content-Type": "application/json"
        },
        body: JSON.stringify({
            playerName: playerName,
            stage: stage,
            score: score
        })
    });
    return await res.json();
}
async function $13f7e2bb7e104b70$export$7041fbfd85e4db6f(id) {
    const res = await fetch(`${$13f7e2bb7e104b70$var$API_BASE_URL}/scores/${id}`, {
        method: "DELETE"
    });
    return await res.json();
}
async function $13f7e2bb7e104b70$export$b0dbb99b1e6a2f28(stage) {
    try {
        const response = await fetch(`${$13f7e2bb7e104b70$var$API_BASE_URL}/rankings/${stage}`);
        const data = await response.json();
        return data;
    } catch (error) {
        console.error("\u30E9\u30F3\u30AD\u30F3\u30B0\u30C7\u30FC\u30BF\u306E\u53D6\u5F97\u306B\u5931\u6557:", error);
        return [];
    }
}


class $99a900461e48a3f4$export$37c32b74f2c813d extends Phaser.Scene {
    constructor(){
        super({
            key: "ResultScene"
        });
    }
    init(data) {
        // ステージ情報を受け取る
        this.stage = data.stage || 1;
        this.newScore = data.newScore || 0;
    }
    create() {
        this.add.text(250, 130, `\u{30B9}\u{30C6}\u{30FC}\u{30B8}${this.stage} \u{30AF}\u{30EA}\u{30A2}\u{FF01}`, {
            fontSize: "40px",
            fill: "#ffffff"
        });
        // ローカルストレージのスコアキーを動的に設定
        let newScoreKey = `Stage${this.stage}NewScore`;
        let topScoreKey = `Stage${this.stage}TopScore`;
        let newScore = parseInt(localStorage.getItem(newScoreKey)) || this.newScore;
        let topScore = parseInt(localStorage.getItem(topScoreKey)) || 0;
        if (topScore < newScore) {
            topScore = newScore;
            localStorage.setItem(topScoreKey, topScore);
            const playerName = localStorage.getItem("playerName");
            // スコアをデータベースに保存
            (0, $13f7e2bb7e104b70$export$bfab3f324e8bcfbb)(playerName, this.stage, topScore);
            this.add.text(250, 200, `\u{65B0}\u{8A18}\u{9332}\u{FF01}`, {
                fontSize: "16px",
                fill: "red"
            });
        }
        this.add.text(250, 230, `\u{4ECA}\u{56DE}\u{306E}\u{30B9}\u{30B3}\u{30A2}: ${newScore}`, {
            fontSize: "32px",
            fill: "#ffffff"
        });
        this.add.text(250, 300, `\u{6700}\u{9AD8}\u{30B9}\u{30B3}\u{30A2}: ${topScore}`, {
            fontSize: "32px",
            fill: "#ffffff"
        });
        const backButton = this.add.text(250, 350, "\u30B9\u30C6\u30FC\u30B8\u9078\u629E\u3078\u623B\u308B", {
            fontSize: "24px",
            fill: "#ffffff",
            padding: {
                x: 10,
                y: 5
            }
        }).setInteractive({
            useHandCursor: true
        }).setDepth(10).on("pointerover", ()=>backButton.setStyle({
                fill: "#ff0"
            })).on("pointerout", ()=>backButton.setStyle({
                fill: "#ffffff"
            })).on("pointerdown", ()=>{
            this.scene.stop(`GameScene${this.stage}`);
            this.scene.start("StageSelectScene");
        });
        const retryButton = this.add.text(250, 420, "\u3084\u308A\u76F4\u3059", {
            fontSize: "24px",
            fill: "#ffffff",
            padding: {
                x: 10,
                y: 5
            }
        }).setInteractive({
            useHandCursor: true
        }).setDepth(10).on("pointerover", ()=>retryButton.setStyle({
                fill: "#ff0"
            })).on("pointerout", ()=>retryButton.setStyle({
                fill: "#ffffff"
            })).on("pointerdown", ()=>{
            this.scene.stop(); // 結果画面を停止
            this.scene.get(`GameScene${this.stage}`).scene.restart();
        });
    }
}


class $739bed710c265bf1$export$15d2c92ee1adc470 extends Phaser.Scene {
    constructor(){
        super({
            key: "ProfileSetup"
        });
    }
    create() {
        this.add.text(200, 50, "\u540D\u524D\u3092\u8A2D\u5B9A\u3057\u3066\u304F\u3060\u3055\u3044\u3002", {
            fontSize: "32px",
            fill: "#fff"
        });
        // HTMLの入力フィールドを作成
        let nameInput = document.createElement("input");
        nameInput.type = "text";
        nameInput.placeholder = "\u540D\u524D\u3092\u5165\u529B";
        nameInput.style.position = "absolute";
        nameInput.style.left = "25%";
        nameInput.style.top = "20%";
        nameInput.style.transform = "translate(-50%, -50%)";
        nameInput.style.fontSize = "24px";
        nameInput.style.padding = "5px";
        document.body.appendChild(nameInput);
        // フォーカスを当てる
        nameInput.focus();
        // 決定ボタン
        let submitButton = document.createElement("button");
        submitButton.innerText = "\u6C7A\u5B9A";
        submitButton.style.position = "absolute";
        submitButton.style.left = "40%";
        submitButton.style.top = "20%";
        submitButton.style.transform = "translate(-50%, -50%)";
        submitButton.style.fontSize = "24px";
        submitButton.style.padding = "5px 10px";
        document.body.appendChild(submitButton);
        // 名前を保存する処理
        const saveName = ()=>{
            let playerName = nameInput.value.trim();
            if (playerName) {
                localStorage.setItem("playerName", playerName);
                alert(`\u{540D}\u{524D}\u{3092}\u{300C}${playerName}\u{300D}\u{306B}\u{8A2D}\u{5B9A}\u{3057}\u{307E}\u{3057}\u{305F}\u{FF01}`);
                nameInput.remove();
                submitButton.remove();
                this.scene.start("StageSelectScene");
            } else alert("\u540D\u524D\u3092\u5165\u529B\u3057\u3066\u304F\u3060\u3055\u3044\uFF01");
        };
        // 決定ボタンのクリックイベント
        submitButton.addEventListener("click", saveName);
        // Enterキーで決定
        nameInput.addEventListener("keypress", (event)=>{
            if (event.key === "Enter") saveName();
        });
        let storedName = localStorage.getItem("playerName");
        if (storedName) {
            nameInput.remove();
            submitButton.remove();
            this.scene.start("StageSelectScene");
        }
    }
}


class $d02663883fe7cd00$export$5b8da01f83922c02 extends Phaser.Scene {
    constructor(){
        super({
            key: "GameOver"
        });
    }
    init(data) {
        this.stage = data.stage || 1; // デフォルトでステージ1
    }
    create() {
        this.add.text(250, 130, "\u30B2\u30FC\u30E0\u30AA\u30FC\u30D0\u30FC", {
            fontSize: "40px",
            fill: "#ffffff"
        });
        const backButton = this.add.text(250, 350, "\u30B9\u30C6\u30FC\u30B8\u9078\u629E\u3078\u623B\u308B", {
            fontSize: "24px",
            fill: "#ffffff",
            padding: {
                x: 10,
                y: 5
            }
        }).setInteractive({
            useHandCursor: true
        }).setDepth(10).on("pointerover", ()=>backButton.setStyle({
                fill: "#ff0"
            })).on("pointerout", ()=>backButton.setStyle({
                fill: "#ffffff"
            })).on("pointerdown", ()=>{
            this.scene.stop(`GameScene${this.stage}`); // ゲームを停止
            this.scene.start("StageSelectScene"); // ステージ選択画面に戻る
        });
        const retryButton = this.add.text(250, 420, "\u3084\u308A\u76F4\u3059", {
            fontSize: "24px",
            fill: "#ffffff",
            padding: {
                x: 10,
                y: 5
            }
        }).setInteractive({
            useHandCursor: true
        }).setDepth(10).on("pointerover", ()=>retryButton.setStyle({
                fill: "#ff0"
            })).on("pointerout", ()=>retryButton.setStyle({
                fill: "#ffffff"
            })).on("pointerdown", ()=>{
            this.scene.stop(); // GameOverシーンを閉じる
            this.scene.get(`GameScene${this.stage}`).scene.restart(); // ゲーム再起動
        });
    }
}



class $9e707c936acd9fd7$export$30e9a3141924146b extends Phaser.Scene {
    constructor(){
        super({
            key: "RankScene"
        });
    }
    async create() {
        this.add.text(200, 50, "\u30E9\u30F3\u30AD\u30F3\u30B0", {
            fontSize: "32px",
            fill: "#fff"
        });
        const backButton = this.add.text(500, 50, "\u30B9\u30C6\u30FC\u30B8\u9078\u629E\u3078\u2192", {
            fontSize: "24px",
            fill: "#ffffff"
        }).setInteractive({
            useHandCursor: true
        }) // カーソルを指アイコンに変更
        .setDepth(10) // 画面最前面に配置
        .on("pointerover", ()=>backButton.setStyle({
                fill: "#ff0"
            })) // マウスオーバー
        .on("pointerout", ()=>backButton.setStyle({
                fill: "#ffffff"
            })) // マウスが離れた時
        .on("pointerdown", ()=>{
            this.scene.stop("RankScene"); // ゲームを停止
            this.scene.start("StageSelectScene"); // ステージ選択画面に戻る
        });
        // スクロール用のコンテナ作成
        this.rankContainer = this.add.container(0, 0);
        let yOffset = 100; // 縦方向の開始位置
        for(let stage = 1; stage <= 5; stage++){
            const stageText = this.add.text(100, yOffset, `\u{30B9}\u{30C6}\u{30FC}\u{30B8}${stage}`, {
                fontSize: "24px",
                fill: "#fff"
            });
            this.rankContainer.add(stageText);
            yOffset += 40;
            // 各ステージのランキングを取得
            const rankings = await (0, $13f7e2bb7e104b70$export$b0dbb99b1e6a2f28)(stage);
            rankings.forEach((entry, index)=>{
                const rankText = this.add.text(100, yOffset + index * 40, `${entry.playerName}: ${entry.score}`, {
                    fontSize: "20px",
                    fill: "#fff"
                });
                this.rankContainer.add(rankText);
            });
            yOffset += rankings.length * 40 + 40; // 次のステージとの間隔を確保
        }
        // カメラの設定（スクロール範囲を制限）
        this.cameras.main.setBounds(0, 0, this.scale.width, Math.max(this.scale.height, yOffset));
        this.cameras.main.setScroll(0, 0);
        // スクロール操作を追加
        this.input.on("wheel", (pointer, gameObjects, deltaX, deltaY, deltaZ)=>{
            this.cameras.main.scrollY += deltaY * 0.5; // スクロール速度を調整
        });
    }
}



const $3ca3d17100669a82$var$enemyInfo = [
    {
        name: 2,
        x: 300,
        y: 150,
        w: 40,
        h: 30,
        rotate: true,
        circle: false,
        hitSize: {
            height: 3,
            width: 1
        },
        velocity: {
            x: 150,
            y: 150
        }
    },
    {
        name: 3,
        x: 400,
        y: 100,
        w: 30,
        h: 30,
        rotate: false,
        circle: true,
        hitSize: {
            height: 1.5,
            width: 1
        },
        velocity: {
            x: 150,
            y: 150
        }
    },
    {
        name: 4,
        x: 500,
        y: 250,
        w: 30,
        h: 30,
        rotate: false,
        circle: false,
        hitSize: {
            height: 1.5,
            width: 4
        },
        velocity: {
            x: 150,
            y: 150
        }
    }
];
const $3ca3d17100669a82$var$obstacleInfo = [
    {
        x: 300,
        y: 500,
        w: 50,
        h: 300
    },
    {
        x: 200,
        y: 150,
        w: 50,
        h: 500
    }
];
const $3ca3d17100669a82$var$starInfo = [
    {
        x: 100,
        y: 300
    }
];
class $3ca3d17100669a82$export$1befa6fd03aaf335 extends (0, $37ce132ae33171bd$export$a4d4c1df08f53d70) {
    constructor(){
        super(2, $3ca3d17100669a82$var$enemyInfo, $3ca3d17100669a82$var$obstacleInfo, $3ca3d17100669a82$var$starInfo);
    }
}



const $8709d9f6ef04b0d4$var$enemyInfo = [
    {
        name: 2,
        x: 300,
        y: 150,
        w: 40,
        h: 30,
        rotate: true,
        circle: false,
        hitSize: {
            height: 3,
            width: 1
        },
        velocity: {
            x: 150,
            y: 150
        }
    },
    {
        name: 3,
        x: 400,
        y: 100,
        w: 30,
        h: 30,
        rotate: false,
        circle: true,
        hitSize: {
            height: 1.5,
            width: 1
        },
        velocity: {
            x: 150,
            y: 150
        }
    },
    {
        name: 4,
        x: 500,
        y: 250,
        w: 30,
        h: 30,
        rotate: false,
        circle: false,
        hitSize: {
            height: 1.5,
            width: 4
        },
        velocity: {
            x: 150,
            y: 150
        }
    }
];
const $8709d9f6ef04b0d4$var$obstacleInfo = [
    {
        x: 300,
        y: 500,
        w: 50,
        h: 300
    },
    {
        x: 200,
        y: 150,
        w: 50,
        h: 500
    }
];
const $8709d9f6ef04b0d4$var$starInfo = [
    {
        x: 100,
        y: 300
    }
];
class $8709d9f6ef04b0d4$export$8e116c7b9640d43d extends (0, $37ce132ae33171bd$export$a4d4c1df08f53d70) {
    constructor(){
        super(3, $8709d9f6ef04b0d4$var$enemyInfo, $8709d9f6ef04b0d4$var$obstacleInfo, $8709d9f6ef04b0d4$var$starInfo);
    }
}



const $514b4bf49cf5e4d3$var$enemyInfo = [
    {
        name: 2,
        x: 300,
        y: 150,
        w: 40,
        h: 30,
        rotate: true,
        circle: false,
        hitSize: {
            height: 3,
            width: 1
        },
        velocity: {
            x: 150,
            y: 150
        }
    },
    {
        name: 3,
        x: 400,
        y: 100,
        w: 30,
        h: 30,
        rotate: false,
        circle: true,
        hitSize: {
            height: 1.5,
            width: 1
        },
        velocity: {
            x: 150,
            y: 150
        }
    },
    {
        name: 4,
        x: 500,
        y: 250,
        w: 30,
        h: 30,
        rotate: false,
        circle: false,
        hitSize: {
            height: 1.5,
            width: 4
        },
        velocity: {
            x: 150,
            y: 150
        }
    }
];
const $514b4bf49cf5e4d3$var$obstacleInfo = [
    {
        x: 300,
        y: 500,
        w: 50,
        h: 300
    },
    {
        x: 200,
        y: 150,
        w: 50,
        h: 500
    }
];
const $514b4bf49cf5e4d3$var$starInfo = [
    {
        x: 100,
        y: 300
    }
];
class $514b4bf49cf5e4d3$export$cf239851c831010e extends (0, $37ce132ae33171bd$export$a4d4c1df08f53d70) {
    constructor(){
        super(4, $514b4bf49cf5e4d3$var$enemyInfo, $514b4bf49cf5e4d3$var$obstacleInfo, $514b4bf49cf5e4d3$var$starInfo);
    }
}



const $5b34716656fe22de$var$enemyInfo = [
    {
        name: 2,
        x: 300,
        y: 150,
        w: 40,
        h: 30,
        rotate: true,
        circle: false,
        hitSize: {
            height: 3,
            width: 1
        },
        velocity: {
            x: 150,
            y: 150
        }
    },
    {
        name: 3,
        x: 400,
        y: 100,
        w: 30,
        h: 30,
        rotate: false,
        circle: true,
        hitSize: {
            height: 1.5,
            width: 1
        },
        velocity: {
            x: 150,
            y: 150
        }
    },
    {
        name: 4,
        x: 500,
        y: 250,
        w: 30,
        h: 30,
        rotate: false,
        circle: false,
        hitSize: {
            height: 1.5,
            width: 4
        },
        velocity: {
            x: 150,
            y: 150
        }
    }
];
const $5b34716656fe22de$var$obstacleInfo = [
    {
        x: 300,
        y: 500,
        w: 50,
        h: 300
    },
    {
        x: 200,
        y: 150,
        w: 50,
        h: 500
    }
];
const $5b34716656fe22de$var$starInfo = [
    {
        x: 100,
        y: 300
    }
];
class $5b34716656fe22de$export$12dd47e04567efa2 extends (0, $37ce132ae33171bd$export$a4d4c1df08f53d70) {
    constructor(){
        super(5, $5b34716656fe22de$var$enemyInfo, $5b34716656fe22de$var$obstacleInfo, $5b34716656fe22de$var$starInfo);
    }
}


const $f8158baafb484661$var$config = {
    type: Phaser.AUTO,
    width: 800,
    height: 600,
    physics: {
        default: "arcade",
        arcade: {
            debug: false
        }
    },
    scene: [
        (0, $739bed710c265bf1$export$15d2c92ee1adc470),
        (0, $784de5bb9f279709$export$c06ab21c92d34448),
        (0, $f87ce123b66b4b44$export$3b63e1c55a110ee1),
        (0, $3ca3d17100669a82$export$1befa6fd03aaf335),
        (0, $8709d9f6ef04b0d4$export$8e116c7b9640d43d),
        (0, $514b4bf49cf5e4d3$export$cf239851c831010e),
        (0, $5b34716656fe22de$export$12dd47e04567efa2),
        (0, $a3369f401e9b2582$export$9fd98d795f8d8487),
        (0, $d02663883fe7cd00$export$5b8da01f83922c02),
        (0, $99a900461e48a3f4$export$37c32b74f2c813d),
        (0, $9e707c936acd9fd7$export$30e9a3141924146b)
    ]
};
var $f8158baafb484661$var$game = new Phaser.Game($f8158baafb484661$var$config);


//# sourceMappingURL=index.2aab3d7d.js.map
